"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootDbGuideSagas = exports.updateLocationDistance = exports.getPointsDistance = void 0;
var effects_1 = require("redux-saga/effects");
var DbGuideAction_1 = require("@/pages/dbguide/actions/DbGuideAction");
var DbGuideState_1 = require("@/pages/dbguide/states/DbGuideState");
var myokay_map_1 = require("@okay/myokay-map");
var DbGuideInfoWindowSchool_1 = require("@/pages/dbguide/components/DbGuideInfoWindowSchool");
var server_1 = require("react-dom/server");
var DbGuideSliderSaga_1 = require("@/pages/dbguide/sagas/DbGuideSliderSaga");
var DbGuideLocationGroup_1 = require("@/pages/dbguide/states/DbGuideLocationGroup");
var GoogleMapDirectionSaga_1 = require("@/pages/dbguide/sagas/GoogleMapDirectionSaga");
var DbGuideInfoWindowSport_1 = require("@/pages/dbguide/components/DbGuideInfoWindowSport");
var DbGuideInfoWindowDevelopment_1 = require("@/pages/dbguide/components/DbGuideInfoWindowDevelopment");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var getDbGuidePlaceInfo = function (state, key) { return state.dbGuide.places
    .find(function (it) { return it.key === key; }); };
var getDevelopmentPlaces = function (state) { return state.dbGuide.menu.items
    .find(function (it) { return it.key === 'developments'; }).children
    .map(function (it) { return state.dbGuide.places.find(function (it2) { return it2.key === it.key; }); }); };
var getSchoolsPlaces = function (state) { return state.dbGuide.menu.items
    .find(function (it) { return it.key === 'schools'; }).children
    .map(function (it) { return state.dbGuide.places.find(function (it2) { return it2.key === it.key; }); }); };
var getSportsPlaces = function (state) { return state.dbGuide.menu.items
    .find(function (it) { return it.key === 'sport'; }).children
    .map(function (it) { return state.dbGuide.places.find(function (it2) { return it2.key === it.key; }); }); };
var getIsWelcome = function (state) { return state.dbGuide.showWelcome; };
var getRestOfMenuItem = function (state, key) { return state.dbGuide.menu.items
    .filter(function (it) { return it.key !== key; }); };
var getHtmlContentSchool = function (school) {
    return server_1.renderToString(DbGuideInfoWindowSchool_1.DbGuideInfoWindowSchool(school));
};
var getHtmlContentSport = function (sport) {
    return server_1.renderToString(DbGuideInfoWindowSport_1.DbGuideInfoWindowSport(sport));
};
var getHtmlContentDevelopment = function (development) {
    return server_1.renderToString(DbGuideInfoWindowDevelopment_1.DbGuideInfoWindowDevelopment(development));
};
var getDbBoundaryObject = function (state) { return (__assign({ kind: myokay_map_1.ObjectTypes.BOUNDARY, key: 'db', points: state.dbGuide.dbBoundaryDefinition }, state.dbGuide.stylesDefinitions.dbBound)); };
var getRouteStyle = function (state) { return state.dbGuide.stylesDefinitions.routeLine; };
var getDevelopmentBoundStyle = function (state) { return state.dbGuide.stylesDefinitions.developmentBound; };
var getDbBoundStyle = function (state) { return state.dbGuide.stylesDefinitions.dbBound; };
var getCurrentPlace = function (state) { return state.dbGuide.currentPlace; };
var getDevelopmentMenuItem = function (state) { return state.dbGuide.menu.items
    .find(function (it) { return it.key === 'developments'; }); };
var getSchoolMenuItem = function (state) { return state.dbGuide.menu.items
    .find(function (it) { return it.key === 'schools'; }); };
var getSportMenuItem = function (state) { return state.dbGuide.menu.items
    .find(function (it) { return it.key === 'sport'; }); };
var getIsPanelOpened = function (state) { return state.dbGuide.detailActive; };
var placeMapObject = function (menuItem) {
    var mapObjects, places, developmentBoundaryStyle, dbBoundary, i, it, mapObjects, places, dbBoundary, _a, _b, _i, i, it, schoolHtml, mapObjects, places, dbBoundary, _c, _d, _e, i, it, sportHtml;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                if (!(menuItem.type === DbGuideState_1.DbGuidePlaceType.DEVELOPMENT)) return [3 /*break*/, 6];
                mapObjects = [];
                return [4 /*yield*/, effects_1.select(getDevelopmentPlaces)];
            case 1:
                places = _f.sent();
                return [4 /*yield*/, effects_1.select(getDevelopmentBoundStyle)];
            case 2:
                developmentBoundaryStyle = _f.sent();
                return [4 /*yield*/, effects_1.select(getDbBoundaryObject)];
            case 3:
                dbBoundary = _f.sent();
                mapObjects.push(dbBoundary);
                for (i in places) {
                    it = places[i];
                    mapObjects.push(__assign({ kind: myokay_map_1.ObjectTypes.BOUNDARY, key: it.key, points: it.path }, developmentBoundaryStyle));
                }
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 4:
                _f.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects(mapObjects))];
            case 5:
                _f.sent();
                _f.label = 6;
            case 6:
                if (!(menuItem.type === DbGuideState_1.DbGuidePlaceType.SCHOOL)) return [3 /*break*/, 15];
                mapObjects = [];
                return [4 /*yield*/, effects_1.select(getSchoolsPlaces)];
            case 7:
                places = _f.sent();
                return [4 /*yield*/, effects_1.select(getDbBoundaryObject)];
            case 8:
                dbBoundary = _f.sent();
                mapObjects.push(dbBoundary);
                _a = [];
                for (_b in places)
                    _a.push(_b);
                _i = 0;
                _f.label = 9;
            case 9:
                if (!(_i < _a.length)) return [3 /*break*/, 12];
                i = _a[_i];
                it = places[i];
                return [4 /*yield*/, effects_1.call(getHtmlContentSchool, it)];
            case 10:
                schoolHtml = _f.sent();
                mapObjects.push({
                    kind: myokay_map_1.ObjectTypes.INFO_WINDOW,
                    key: it.key,
                    lat: it.center.lat,
                    lng: it.center.lng,
                    content: schoolHtml,
                });
                _f.label = 11;
            case 11:
                _i++;
                return [3 /*break*/, 9];
            case 12: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 13:
                _f.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects(mapObjects))];
            case 14:
                _f.sent();
                _f.label = 15;
            case 15:
                if (!(menuItem.type === DbGuideState_1.DbGuidePlaceType.SPORT)) return [3 /*break*/, 24];
                mapObjects = [];
                return [4 /*yield*/, effects_1.select(getSportsPlaces)];
            case 16:
                places = _f.sent();
                return [4 /*yield*/, effects_1.select(getDbBoundaryObject)];
            case 17:
                dbBoundary = _f.sent();
                mapObjects.push(dbBoundary);
                _c = [];
                for (_d in places)
                    _c.push(_d);
                _e = 0;
                _f.label = 18;
            case 18:
                if (!(_e < _c.length)) return [3 /*break*/, 21];
                i = _c[_e];
                it = places[i];
                if (!it.center)
                    return [3 /*break*/, 20];
                return [4 /*yield*/, effects_1.call(getHtmlContentSport, it)];
            case 19:
                sportHtml = _f.sent();
                mapObjects.push({
                    kind: myokay_map_1.ObjectTypes.INFO_WINDOW,
                    key: it.key,
                    lat: it.center.lat,
                    lng: it.center.lng,
                    content: sportHtml,
                });
                _f.label = 20;
            case 20:
                _e++;
                return [3 /*break*/, 18];
            case 21: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 22:
                _f.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects(mapObjects))];
            case 23:
                _f.sent();
                _f.label = 24;
            case 24: return [2 /*return*/];
        }
    });
};
var showDetailPanel = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setAccordianActive(false))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setDetailHidden(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setAccordianHidden(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setDetailActive(true))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var hideDetailPanel = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setDetailActive(false))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setAccordianHidden(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setAccordianActive(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setDetailHidden(true))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
function getPointsDistance(from, to) {
    var distanceInMeter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(GoogleMapDirectionSaga_1.getPointsDistanceMeter, from, to)];
            case 1:
                distanceInMeter = _a.sent();
                if (distanceInMeter > 1000) {
                    return [2 /*return*/, [(distanceInMeter / 1000).toFixed(2), 'km']];
                }
                return [2 /*return*/, [distanceInMeter.toFixed(2), 'm']];
        }
    });
}
exports.getPointsDistance = getPointsDistance;
function updateLocationDistance(locations, placeInfo) {
    var _a, _b, _i, i, _c, _d, _e, j, walkLocation, _f, distanceValue, distanceUnit;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [];
                for (_b in locations)
                    _a.push(_b);
                _i = 0;
                _g.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 6];
                i = _a[_i];
                if (!(locations[i].type === DbGuideLocationGroup_1.DbGuideLocationType.WALKING)) return [3 /*break*/, 5];
                _c = [];
                for (_d in locations[i].locations)
                    _c.push(_d);
                _e = 0;
                _g.label = 2;
            case 2:
                if (!(_e < _c.length)) return [3 /*break*/, 5];
                j = _c[_e];
                walkLocation = locations[i].locations[j];
                return [4 /*yield*/, effects_1.call(getPointsDistance, placeInfo.center, walkLocation.center)];
            case 3:
                _f = _g.sent(), distanceValue = _f[0], distanceUnit = _f[1];
                locations[i].locations[j].distanceValue = Number.parseInt(distanceValue, 10);
                locations[i].locations[j].distanceUnit = distanceUnit;
                _g.label = 4;
            case 4:
                _e++;
                return [3 /*break*/, 2];
            case 5:
                _i++;
                return [3 /*break*/, 1];
            case 6: return [2 /*return*/, null];
        }
    });
}
exports.updateLocationDistance = updateLocationDistance;
var handlePlaceInfoClick = function (placeInfo) {
    var info, developmentBoundaryStyle, mapObjects, info, schoolHtml, info, info, info, sportHtml, info, info;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.DEVELOPMENT)) return [3 /*break*/, 7];
                info = placeInfo;
                return [4 /*yield*/, effects_1.select(getDevelopmentBoundStyle)];
            case 1:
                developmentBoundaryStyle = _a.sent();
                mapObjects = [];
                mapObjects.push(__assign({ kind: myokay_map_1.ObjectTypes.BOUNDARY, key: 'b3', points: info.path }, developmentBoundaryStyle));
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects(mapObjects))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(updateLocationDistance, info.location, placeInfo)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.SCHOOL)) return [3 /*break*/, 13];
                info = placeInfo;
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt({
                        center: info.center,
                        zoom: 17,
                    }))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getHtmlContentSchool, info)];
            case 9:
                schoolHtml = _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects([
                        {
                            kind: myokay_map_1.ObjectTypes.INFO_WINDOW,
                            lat: info.center.lat,
                            lng: info.center.lng,
                            content: schoolHtml,
                        },
                    ]))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.EMERGENCY)) return [3 /*break*/, 17];
                info = placeInfo;
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.onMapReady())];
            case 14:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 15:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 16:
                _a.sent();
                _a.label = 17;
            case 17:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.TRANSPORT)) return [3 /*break*/, 20];
                info = placeInfo;
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 18:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 19:
                _a.sent();
                _a.label = 20;
            case 20:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.SPORT)) return [3 /*break*/, 26];
                info = placeInfo;
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt({
                        center: info.center,
                        zoom: 17,
                    }))];
            case 21:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getHtmlContentSport, info)];
            case 22:
                sportHtml = _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects([
                        {
                            kind: myokay_map_1.ObjectTypes.INFO_WINDOW,
                            lat: info.center.lat,
                            lng: info.center.lng,
                            content: sportHtml,
                        },
                    ]))];
            case 23:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 24:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 25:
                _a.sent();
                _a.label = 26;
            case 26:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.USEFUL_LINK)) return [3 /*break*/, 29];
                info = placeInfo;
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 27:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 28:
                _a.sent();
                _a.label = 29;
            case 29:
                if (!(placeInfo.type === DbGuideState_1.DbGuidePlaceType.BUSINESS_DIRECTORY)) return [3 /*break*/, 32];
                info = placeInfo;
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(info))];
            case 30:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showDetailPanel)];
            case 31:
                _a.sent();
                _a.label = 32;
            case 32: return [2 /*return*/];
        }
    });
};
var watchMenuItemClickSaga = function () {
    var payload, menuItem, state, isShowingWelcome, menuItems, _a, _b, _i, i, otherMenuItem, placeInfo;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 21];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_MENU_ITEM_CLICK)];
            case 1:
                payload = (_c.sent()).payload;
                menuItem = payload.menuItem;
                state = payload.state;
                return [4 /*yield*/, effects_1.select(getIsWelcome)];
            case 2:
                isShowingWelcome = _c.sent();
                if (!isShowingWelcome) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.onViewMapClicked())];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4:
                if (!menuItem.children) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.call(hideDetailPanel)];
            case 5:
                _c.sent();
                if (!(!menuItem.isOpened || state)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMenuItemOpen(menuItem.key, true))];
            case 6:
                _c.sent();
                return [4 /*yield*/, effects_1.select(getRestOfMenuItem, menuItem.key)];
            case 7:
                menuItems = _c.sent();
                _a = [];
                for (_b in menuItems)
                    _a.push(_b);
                _i = 0;
                _c.label = 8;
            case 8:
                if (!(_i < _a.length)) return [3 /*break*/, 11];
                i = _a[_i];
                otherMenuItem = menuItems[i];
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMenuItemOpen(otherMenuItem.key, false))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10:
                _i++;
                return [3 /*break*/, 8];
            case 11: return [4 /*yield*/, effects_1.call(placeMapObject, menuItem)];
            case 12:
                _c.sent();
                return [3 /*break*/, 16];
            case 13: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMenuItemOpen(menuItem.key, false))];
            case 14:
                _c.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.resetMap())];
            case 15:
                _c.sent();
                _c.label = 16;
            case 16: return [3 /*break*/, 20];
            case 17: return [4 /*yield*/, effects_1.select(getDbGuidePlaceInfo, menuItem.key)];
            case 18:
                placeInfo = _c.sent();
                if (!placeInfo)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(handlePlaceInfoClick, placeInfo)];
            case 19:
                _c.sent();
                _c.label = 20;
            case 20: return [3 /*break*/, 0];
            case 21: return [2 /*return*/];
        }
    });
};
var watchSliderPrevClickSaga = function () {
    var slider, width;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_SLIDER_PREV_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(DbGuideSliderSaga_1.getSlider)];
            case 2:
                slider = _a.sent();
                return [4 /*yield*/, effects_1.call(DbGuideSliderSaga_1.getSliderWidth, slider)];
            case 3:
                width = _a.sent();
                return [4 /*yield*/, effects_1.call(DbGuideSliderSaga_1.setSliderScrollXBy, slider, 0 - width)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchSliderNextClickSaga = function () {
    var slider, width;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_SLIDER_NEXT_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(DbGuideSliderSaga_1.getSlider)];
            case 2:
                slider = _a.sent();
                return [4 /*yield*/, effects_1.call(DbGuideSliderSaga_1.getSliderWidth, slider)];
            case 3:
                width = _a.sent();
                return [4 /*yield*/, effects_1.call(DbGuideSliderSaga_1.setSliderScrollXBy, slider, width)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchDetailBackClickSaga = function () {
    var currentPlace, menuItem, menuItem, menuItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_DETAIL_BACK_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(hideDetailPanel)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentPlace)];
            case 3:
                currentPlace = _a.sent();
                if (!(currentPlace.type === DbGuideState_1.DbGuidePlaceType.DEVELOPMENT)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.select(getDevelopmentMenuItem)];
            case 4:
                menuItem = _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.onMenuItemClick(menuItem, true))];
            case 5:
                _a.sent();
                return [3 /*break*/, 14];
            case 6:
                if (!(currentPlace.type === DbGuideState_1.DbGuidePlaceType.SCHOOL)) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.select(getSchoolMenuItem)];
            case 7:
                menuItem = _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.onMenuItemClick(menuItem, true))];
            case 8:
                _a.sent();
                return [3 /*break*/, 14];
            case 9:
                if (!(currentPlace.type === DbGuideState_1.DbGuidePlaceType.SPORT)) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.select(getSportMenuItem)];
            case 10:
                menuItem = _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.onMenuItemClick(menuItem, true))];
            case 11:
                _a.sent();
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.resetMap())];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setCurrentPlace(null))];
            case 15:
                _a.sent();
                return [3 /*break*/, 0];
            case 16: return [2 /*return*/];
        }
    });
};
var watchDetailPlaceClickSaga = function () {
    var payload, place, current, from, _a, path, duration, routeStyle, fromPinObject, toPinObject, pathObject;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_DETAIL_PLACE_CLICK)];
            case 1:
                payload = (_b.sent()).payload;
                place = payload;
                return [4 /*yield*/, effects_1.select(getCurrentPlace)];
            case 2:
                current = _b.sent();
                from = current.center;
                return [4 /*yield*/, effects_1.call(GoogleMapDirectionSaga_1.getPath, from, place.center)];
            case 3:
                _a = _b.sent(), path = _a.path, duration = _a.duration;
                return [4 /*yield*/, effects_1.select(getRouteStyle)];
            case 4:
                routeStyle = _b.sent();
                fromPinObject = {
                    kind: myokay_map_1.ObjectTypes.PIN,
                    key: current.key,
                    lat: current.center.lat,
                    lng: current.center.lng,
                };
                toPinObject = {
                    kind: myokay_map_1.ObjectTypes.PIN,
                    key: place.name,
                    lat: place.center.lat,
                    lng: place.center.lng,
                };
                pathObject = __assign({ path: path, kind: myokay_map_1.ObjectTypes.DIRECTION, key: current.key + "-" + place.name }, routeStyle);
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 5:
                _b.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects([
                        fromPinObject,
                        toPinObject,
                        pathObject,
                    ]))];
            case 6:
                _b.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchDetailTitleClickSaga = function () {
    var payload, section, pinObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_DETAIL_TITLE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                section = payload;
                if (!section.center)
                    return [2 /*return*/];
                pinObject = {
                    kind: myokay_map_1.ObjectTypes.PIN,
                    key: section.title,
                    lat: section.center.lat,
                    lng: section.center.lng,
                };
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt({
                        center: section.center,
                        zoom: 17,
                    }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects([
                        pinObject,
                    ]))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchDetailRouteClickSaga = function () {
    var payload, route, routeStyle, mapObjects, i, path, pathObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_DETAIL_ROUTE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                route = payload;
                return [4 /*yield*/, effects_1.select(getRouteStyle)];
            case 2:
                routeStyle = _a.sent();
                mapObjects = [];
                for (i in route.path) {
                    path = route.path[i];
                    pathObject = __assign({ path: path, kind: myokay_map_1.ObjectTypes.DIRECTION, key: route.name }, routeStyle);
                    mapObjects.push(pathObject);
                }
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects(mapObjects))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchMapReadySaga = function () {
    var mapObjects, dbBoundary, menuItems, _a, _b, _i, i, otherMenuItem;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_MAP_READY)];
            case 1:
                _c.sent();
                mapObjects = [];
                return [4 /*yield*/, effects_1.select(getDbBoundaryObject)];
            case 2:
                dbBoundary = _c.sent();
                mapObjects.push(dbBoundary);
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapOpt(null))];
            case 3:
                _c.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMapObjects(mapObjects))];
            case 4:
                _c.sent();
                return [4 /*yield*/, effects_1.select(getRestOfMenuItem, '')];
            case 5:
                menuItems = _c.sent();
                _a = [];
                for (_b in menuItems)
                    _a.push(_b);
                _i = 0;
                _c.label = 6;
            case 6:
                if (!(_i < _a.length)) return [3 /*break*/, 9];
                i = _a[_i];
                otherMenuItem = menuItems[i];
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.setMenuItemOpen(otherMenuItem.key, false))];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8:
                _i++;
                return [3 /*break*/, 6];
            case 9: return [3 /*break*/, 0];
            case 10: return [2 /*return*/];
        }
    });
};
var watchMapResetSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_RESET_MAP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(hideDetailPanel)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.onMapReady())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMouseEventSaga = function () {
    var payload, eventName, item, developmentInfo, isPanelOpened, infowindowHtml, infoWindow;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(DbGuideAction_1.default.ON_DBGUIDE_MOUSE_EVENT)];
            case 1:
                payload = (_a.sent()).payload;
                eventName = payload.eventName;
                item = payload.item;
                return [4 /*yield*/, effects_1.select(getDbGuidePlaceInfo, item.key)];
            case 2:
                developmentInfo = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsPanelOpened)];
            case 3:
                isPanelOpened = _a.sent();
                if (!(eventName === 'click' && item.kind === myokay_map_1.ObjectTypes.BOUNDARY && !isPanelOpened)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.call(getHtmlContentDevelopment, developmentInfo)];
            case 4:
                infowindowHtml = _a.sent();
                infoWindow = {
                    kind: myokay_map_1.ObjectTypes.INFO_WINDOW,
                    key: developmentInfo.key,
                    lat: developmentInfo.center.lat,
                    lng: developmentInfo.center.lng,
                    content: infowindowHtml,
                };
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.addMapObject(infoWindow))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                if (!(eventName === 'closeclick' && item.kind === myokay_map_1.ObjectTypes.INFO_WINDOW)) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(DbGuideAction_1.default.removeInfoWindow(item.key))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var rootDbGuideSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchMenuItemClickSaga: watchMenuItemClickSaga,
    watchSliderPrevClickSaga: watchSliderPrevClickSaga,
    watchSliderNextClickSaga: watchSliderNextClickSaga,
    watchDetailBackClickSaga: watchDetailBackClickSaga,
    watchDetailPlaceClickSaga: watchDetailPlaceClickSaga,
    watchDetailTitleClickSaga: watchDetailTitleClickSaga,
    watchDetailRouteClickSaga: watchDetailRouteClickSaga,
    watchMapReadySaga: watchMapReadySaga,
    watchMapResetSaga: watchMapResetSaga,
    watchMouseEventSaga: watchMouseEventSaga,
};
exports.rootDbGuideSagas = rootDbGuideSagas;
